module.exports = __webpack_public_path__ + "static/media/checkout-loreal.1b9b48e7.png";


//////////////////
// WEBPACK FOOTER
// ./client/assets/winter-2019/checkout-loreal.png
// module id = 150
// module chunks = 0